// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Cp","card":"e_Dp","wideContainer":"e_Ep","containerHollow":"e_Fp"};